import { render } from "./PortfolioSummary.vue?vue&type=template&id=ed2965b6&scoped=true"
import script from "./PortfolioSummary.vue?vue&type=script&lang=js"
export * from "./PortfolioSummary.vue?vue&type=script&lang=js"

import "./PortfolioSummary.vue?vue&type=style&index=0&id=ed2965b6&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed2965b6"]])

export default __exports__